var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
import { htmlSafe } from '@ember/template';
import { TrackedAsyncData } from 'ember-async-data';
import { cached } from '@glimmer/tracking';
let SessionType = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('boolean'), _dec4 = attr('boolean'), _dec5 = belongsTo('assessment-option', {
  async: true,
  inverse: 'sessionTypes'
}), _dec6 = belongsTo('school', {
  async: true,
  inverse: 'sessionTypes'
}), _dec7 = hasMany('aamc-method', {
  async: true,
  inverse: 'sessionTypes'
}), _dec8 = hasMany('session', {
  async: true,
  inverse: 'sessionType'
}), _class = class SessionType extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "calendarColor", _descriptor2, this);
    _initializerDefineProperty(this, "active", _descriptor3, this);
    _initializerDefineProperty(this, "assessment", _descriptor4, this);
    _initializerDefineProperty(this, "assessmentOption", _descriptor5, this);
    _initializerDefineProperty(this, "school", _descriptor6, this);
    _initializerDefineProperty(this, "aamcMethods", _descriptor7, this);
    _initializerDefineProperty(this, "sessions", _descriptor8, this);
  }
  get _aamcMethodsData() {
    return new TrackedAsyncData(this.aamcMethods);
  }
  get safeCalendarColor() {
    const pattern = new RegExp('^#[a-fA-F0-9]{6}$');
    if (pattern.test(this.calendarColor)) {
      return htmlSafe(this.calendarColor);
    }
    return '';
  }
  get sessionCount() {
    return this.hasMany('sessions').ids().length;
  }
  get firstAamcMethod() {
    if (!this._aamcMethodsData.isResolved) {
      return undefined;
    }
    return this._aamcMethodsData.value[0];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "calendarColor", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "assessment", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "assessmentOption", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "school", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "aamcMethods", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_aamcMethodsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_aamcMethodsData"), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "sessions", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SessionType as default };